export default "__VITE_ASSET__ILQeSvkt__"